import { useEffect, useRef, useState } from "react";

function PageTransition({ path }) {
  const hasMounted = useRef(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return undefined;
    }

    setIsVisible(true);
    const timer = window.setTimeout(() => setIsVisible(false), 840);

    return () => window.clearTimeout(timer);
  }, [path]);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed inset-0 z-[80] animate-page-curtain bg-outerspace"
      aria-hidden="true"
    />
  );
}

export default PageTransition;
